'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const gt=require('../../../dist-es6/client/utilities/groupTreeExtensions');
const strEx=require('pulsar-utils/dist-es6/extensions/stringExtensions');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const DisplaySettingsService=require('../../../dist-es6/client/services/displaySettingsService');let

GroupTreeService=function(_BaseService){_inherits(GroupTreeService,_BaseService);
function GroupTreeService(displaySettingsService){_classCallCheck(this,GroupTreeService);
_.ensureInstanceOf(DisplaySettingsService,displaySettingsService);var _this=_possibleConstructorReturn(this,

_BaseService.call(this));

_this._displaySettingsService=displaySettingsService;

_this.reset();return _this;
}GroupTreeService.prototype.

reset=function reset(){
this._groupTree=null;
this._groupsById=null;
this._selectedGroup=null;
this._selectedGroupParents=[];
this._pendingSelectionId=null;
this._expandedGroups=null;
};GroupTreeService.prototype.

expandAllGroups=function expandAllGroups(){
this.expandedGroups=_.values(this._groupsById).filter(function(g){return _.exists(g.id)&&g.children.length!==0});
};GroupTreeService.prototype.

collapseAllGroups=function collapseAllGroups(){
this.expandedGroups=[];
};GroupTreeService.prototype.






















































selectGroupWithId=function selectGroupWithId(id){let{forceExpansion=!1}=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};
if(!_.exists(this._groupsById)){
this._pendingSelectionId=id;
return;
}

let lastSelectedGroupId=_.get(this._selectedGroup,'id');

this._selectedGroup=this._groupsById[id]||this._groupsById[null];
this._selectedGroupParents=_getParentGroupsOf(this._selectedGroup,this._parentGroupMap);
this._displaySettingsService.stickySettings.set('selectedGroupId',this.selectedGroup.id);

if(!forceExpansion&&lastSelectedGroupId===id){
return;
}

const collapsedParentGroups=_.without.apply(_,[this._selectedGroupParents].concat(_toConsumableArray(this._expandedGroups)));
if(collapsedParentGroups.length===0){
return;
}

this.expandedGroups=_.concat(this._expandedGroups,collapsedParentGroups);
};GroupTreeService.prototype.

linkController=function linkController(controller){
controller.groupTreeService=this;

if(_.exists(controller.$state.params.groupId)){
this.selectGroupWithId(controller.$state.params.groupId);
}

controller.$scope.$watch('controller.groupTreeService.selectedGroup',function(newlySelectedGroup,oldSelectedGroup){
if(_.exists(newlySelectedGroup)){
controller.$state.go(controller.stateName,{groupId:newlySelectedGroup.id});
controller.dataService.selectGroupDataFor(newlySelectedGroup.id);
}
});
};_createClass(GroupTreeService,[{key:'groupTree',get:function(){return this._groupTree},set:function(groupTree){_.ensureArrayOf(Object,groupTree);if(groupTree.length===0||groupTree[0].id!==null){throw new Error(`Expecting at least 'Organization' group`)}this._groupTree=groupTree;this._parentGroupMap=_getGroupParentMap(this._groupTree);const flattenedGroupsTree=[].concat(_toConsumableArray(treeUtils.flatten(groupTree)));this._groupsById=_(flattenedGroupsTree).keyBy(function(group){return group.id}).value();const stickyExpandedGroups=this._displaySettingsService.stickySettings.get('expandedSidebarGroups');if(!_.exists(stickyExpandedGroups)){this.expandedGroups=flattenedGroupsTree.filter(function(g){return g.children.length!==0})}else{this._expandedGroups=flattenedGroupsTree.filter(function(g){return stickyExpandedGroups.has(g.id)})}if(_.exists(this._pendingSelectionId)){this.selectGroupWithId(this._pendingSelectionId);this._pendingSelectionId=null;return}this.selectGroupWithId(this._displaySettingsService.stickySettings.get('selectedGroupId'))}},{key:'expandedGroups',get:function(){return this._expandedGroups},set:function(expandedGroups){this._expandedGroups=expandedGroups;if(!_.exists(this._expandedGroups)){return}this._displaySettingsService.stickySettings.set('expandedSidebarGroups',new Set(this._expandedGroups.map(function(g){return g.id})))}},{key:'selectedGroup',get:function(){return this._selectedGroup}},{key:'selectedGroupParents',get:function(){return this._selectedGroupParents}}]);return GroupTreeService}(BaseService);


function _getGroupParentMap(groupTree){
const parentMap=new Map;

gt(groupTree).walkTreeFromRoot(function(node,depth,curPath){
const[parentPath]=strEx(curPath).splitBeforeLast('.children');
const parent=_.get(groupTree,parentPath);
if(_.exists(parent)){
parentMap.set(node,parent);
}
});

return parentMap;
}

function _getParentGroupsOf(group,parentGroupMap){
const parentGroups=[];

if(_.exists(group)){
let lastGroup=group;
while(lastGroup=parentGroupMap.get(lastGroup)){
parentGroups.push(lastGroup);
}
}

return parentGroups;
}

module.exports=GroupTreeService;
//# sourceMappingURL=groupTreeService.js.map
